import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Filters } from '@ui/src';
import { CardsTransactions, CustomerType } from '../../types';

export interface CustomerCards {
  isLoading: boolean;
  values?: CardsTransactions[];
  cardId?: string;
  sort?: {
    sortProp: string;
    sortDir: string;
  };
  filters?: Filters;
  requestInProgress: boolean;
  customerType?: string;
}

const initialState: CustomerCards = {
  isLoading: true,
  requestInProgress: false,
  values: undefined,
};

export const customerCardsSlice = createSlice({
  name: 'customerCards',
  initialState,
  reducers: {
    getCardsTransactions: (
      state,
      action: PayloadAction<{
        name?: string;
        direction?: 'asc' | 'desc';
        filters?: Filters;
        cardId: string;
        customerType: CustomerType;
      }>,
    ) => {
      state.cardId = action.payload.cardId;
      state.requestInProgress = true;
      state.customerType = action.payload.customerType;

      if (action.payload.name && action.payload.direction) {
        state.sort = {
          sortDir: action.payload.direction,
          sortProp: action.payload.name,
        };
      }

      if (action.payload.filters) {
        state.filters = action.payload.filters;
      }
    },
    getCardsTransactionsSuccess: (
      state,
      action: PayloadAction<CardsTransactions[]>,
    ) => {
      state.isLoading = false;
      state.values = action.payload;
      state.requestInProgress = false;
    },
    onSortCardsTransactionsList: (
      state,
      action: PayloadAction<{ name: string; direction: 'asc' | 'desc' }>,
    ) => {
      state.sort = {
        sortDir: action.payload.direction,
        sortProp: action.payload.name,
      };
      state.requestInProgress = true;
    },
    onSortCardsTransactionsListSuccess: (
      state,
      action: PayloadAction<CardsTransactions[]>,
    ) => {
      state.requestInProgress = false;
      state.values = action.payload;
    },
    onFilterCardsTransactionsList: (state, action: PayloadAction<Filters>) => {
      state.requestInProgress = true;
      state.filters = action.payload;
    },
    onFilterListCardsTransactionsSuccess: (
      state,
      action: PayloadAction<CardsTransactions[]>,
    ) => {
      state.requestInProgress = false;
      state.values = action.payload;
    },
    clearCardsState: (state) => {
      state.isLoading = true;
      state.requestInProgress = false;
      state.values = undefined;
      state.customerType = undefined;
    },
  },
});

export const {
  clearCardsState,
  getCardsTransactions,
  getCardsTransactionsSuccess,
  onSortCardsTransactionsList,
  onSortCardsTransactionsListSuccess,
  onFilterCardsTransactionsList,
  onFilterListCardsTransactionsSuccess,
} = customerCardsSlice.actions;

export default customerCardsSlice.reducer;
